<template>
    <div>
        <popup :title="title" v-if="openPopup" @close="hidePopup()" @on-cancel-click="hidePopup()" @on-save-click="onSaveClick"
               :displayPopup="openPopup" :showAddNewBtn="false" class="box-popup-gpi">
            <b-container style="width:auto; text-align: left;">
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 15px; padding-bottom: 0px; text-align: left;">
                            <span style="color: yellow; font-weight: bold;">
                                GPI Substitution
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">
                            &nbsp;
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Enter Source GPI</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <b-form-input v-model="Source_GPI" placeholder="Source GPI" style="width: 325px;"></b-form-input>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Enter Target GPI</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <b-form-input v-model="Target_GPI" placeholder="Target GPI" style="width: 325px;"></b-form-input>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Supporting Documentation</span>
                            <b-form-textarea v-model="Support_Doc" placeholder="Supporting Documentation" style="width: 325px; height: 200px;"      
                            rows="3" max-rows="10"></b-form-textarea>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="SOURCENOTENTERED">
                            <span style="color: orangered;">Please enter a Source GPI!</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="TARGETNOTENTERED">
                            <span style="color: orangered;">Please enter a Target GPI!</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="SUPPORTNOTENTERED">
                            <span style="color: orangered;">Please enter Supporting Documentation!</span>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </popup>
    </div>
</template>

<script>
    import axios from "axios";
    import { required } from "vee-validate/dist/rules";
    import { extend } from "vee-validate";

    extend("required", {
        ...required,
        message: "This field is required"
    });

    export default {
        name: "gpi-subs-popup",
        props: {
        },
        data: function () {
            return {
                openPopup: false,
                title: 'GPI Substitution',
                Source_GPI: '',
                Target_GPI: '',
                Support_Doc: '',
                SOURCENOTENTERED: false,
                TARGETNOTENTERED: false,
                SUPPORTNOTENTERED: false,
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
            // console.log('patientId in mounted: ' + this.patientId);
        },
        computed: {

        },
        watch: {

        },
        methods: {
            showPopup() {
                var vm = this;
                vm.title = 'GPI Substitution Popup';
                vm.openPopup = true;
                vm.Source_GPI = '';
                vm.Target_GPI = '';
                vm.Support_Doc = '';
                vm.SOURCENOTENTERED = false;
                vm.TARGETNOTENTERED = false;
                vm.SUPPORTNOTENTERED = false;
            },
            hidePopup() {
                this.openPopup = false;
            },

            async onSaveClick() {
                let vm = this;

                vm.SOURCENOTENTERED = false;
                vm.TARGETNOTENTERED = false;
                vm.SUPPORTNOTENTERED = false;

                //console.log();
                //vm.selectedUser is an entire object you need to select a property of the object
                if (vm.Source_GPI == '') {
                    vm.SOURCENOTENTERED = true;
                }
                if (vm.Target_GPI == '') {
                    vm.TARGETNOTENTERED = true;
                }
                if (vm.Support_Doc == '') {
                    vm.SUPPORTNOTENTERED = true;
                }

                if (vm.SOURCENOTENTERED == false && vm.TARGETNOTENTERED == false && vm.SUPPORTNOTENTERED == false) {
                    
                     await axios
                        .post("../../Common/Services/EmarClientOperations.svc/SetGPISub",
                            {
                                SOURCE_GPI: vm.Source_GPI,
                                TARGET_GPI: vm.Target_GPI,
                                SUPPORTING_DOC: vm.Support_Doc
                            }
                        );

                        vm.hidePopup();
                        location.reload();
                }
                
            },
        }
    }
</script>

<style scoped>
    .box-popup-gpi {
        width: 460px !important;
        height: 450px !important;
    }

    ::v-deep .modal-title {
        font-size: 1.25rem;
    }

    ::v-deep *,
    ::after,
    ::before {
        box-sizing: border-box;
    }
</style>